import {useContext} from 'react';
import EnvironmentContext from './EnvironmentContext';

const useEnvironment = () => useContext(EnvironmentContext);

export default useEnvironment;
